import { utils } from '@neo-one/utils';
import BigNumber from 'bignumber.js';
import BN from 'bn.js';
export const serializeObject = (object) => Object.entries(object).reduce((acc, [key, value]) => ({
    ...acc,
    [key]: serialize(value),
}), {});
export const serializeObjectToken = (object) => ({
    type: 'Object',
    value: serializeObject(object),
});
export const serializeArray = (array) => ({
    type: 'Array',
    value: array.map(serialize),
});
export const serializeMap = (map) => {
    const result = [];
    map.forEach((value, key) => result.push(serialize([key, value])));
    return {
        type: 'Map',
        value: result,
    };
};
export const serialize = (value) => {
    if (value === null) {
        return {
            type: 'Null',
        };
    }
    if (value === undefined) {
        return {
            type: 'Undefined',
        };
    }
    if (typeof value === 'boolean') {
        return {
            type: 'Boolean',
            value,
        };
    }
    if (typeof value === 'number') {
        return {
            type: 'Number',
            value,
        };
    }
    if (typeof value === 'string') {
        return {
            type: 'String',
            value,
        };
    }
    if (value instanceof Buffer) {
        return {
            type: 'Buffer',
            value: value.toString('hex'),
        };
    }
    if (value instanceof Map) {
        return serializeMap(value);
    }
    if (BN.isBN(value)) {
        return {
            type: 'BN',
            value: value.toString(),
        };
    }
    if (BigNumber.isBigNumber(value)) {
        return {
            type: 'BigNumber',
            value: value.toString(),
        };
    }
    if (Array.isArray(value)) {
        return serializeArray(value);
    }
    if (value instanceof Error) {
        return {
            type: 'Error',
            message: value.message,
            stack: value.stack,
        };
    }
    if (value.type === 'SourceMap') {
        return {
            type: 'SourceMap',
            value: serializeObject(value.value),
        };
    }
    if (typeof value === 'object') {
        return serializeObjectToken(value);
    }
    throw new Error(`Attempted to serialize invalid value: ${JSON.stringify(value)}`);
};
export const deserializeObject = (serializedObject) => Object.entries(serializedObject).reduce((acc, [key, value]) => ({
    ...acc,
    [key]: deserialize(value),
}), {});
export const deserializeArray = (serializedArray) => serializedArray.map(deserialize);
export const deserialize = (serializedValue) => {
    switch (serializedValue.type) {
        case 'Undefined':
            return undefined;
        case 'Null':
            return null;
        case 'String':
            return serializedValue.value;
        case 'Number':
            return serializedValue.value;
        case 'Boolean':
            return serializedValue.value;
        case 'BigNumber':
            return new BigNumber(serializedValue.value);
        case 'BN':
            return new BN(serializedValue.value);
        case 'Buffer':
            return Buffer.from(serializedValue.value, 'hex');
        case 'Object':
            return deserializeObject(serializedValue.value);
        case 'Array':
            return deserializeArray(serializedValue.value);
        case 'Map':
            return deserializeArray(serializedValue.value);
        case 'SourceMap':
            return Promise.resolve(deserializeObject(serializedValue.value));
        case 'Error':
            const err = new Error(serializedValue.message);
            err.stack = serializedValue.stack;
            throw err;
        default:
            utils.assertNever(serializedValue);
            throw new Error('For TS');
    }
};

//# sourceMappingURL=serializeUtils.js.map
